import { Link } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";
import { Button } from "@/components/ui/button";

export function AppShell({ children }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans">
      <header
        className="border-b border-zinc-800 sticky top-0 z-10"
        style={{ backgroundColor: "var(--purely-navy)" }}
        data-testid="app-header"
      >
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3"
            data-testid="app-home-link"
          >
            <img
              src={require("../assets/purely_it_logo.png")}
              alt="Purely IT Temp Monitor"
              className="h-9 w-auto"
            />
            <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-400 hidden sm:inline">
              temp monitor
            </span>
          </Link>

          <nav className="flex items-center gap-1 text-sm">
            <Link
              to="/"
              data-testid="nav-dashboard-link"
              className="px-3 py-2 text-zinc-400 hover:text-zinc-100 uppercase tracking-widest text-xs"
            >
              Dashboard
            </Link>
            <Link
              to="/alerts"
              data-testid="nav-alerts-link"
              className="px-3 py-2 text-zinc-400 hover:text-zinc-100 uppercase tracking-widest text-xs"
            >
              Alerts
            </Link>
            <Link
              to="/history"
              data-testid="nav-history-link"
              className="px-3 py-2 text-zinc-400 hover:text-zinc-100 uppercase tracking-widest text-xs"
            >
              History
            </Link>
            {user?.role === "admin" && (
              <>
                <Link
                  to="/thresholds"
                  data-testid="nav-thresholds-link"
                  className="px-3 py-2 text-zinc-400 hover:text-zinc-100 uppercase tracking-widest text-xs"
                >
                  Thresholds
                </Link>
                <Link
                  to="/recipients"
                  data-testid="nav-recipients-link"
                  className="px-3 py-2 text-zinc-400 hover:text-zinc-100 uppercase tracking-widest text-xs"
                >
                  Recipients
                </Link>
                <Link
                  to="/users"
                  data-testid="nav-users-link"
                  className="px-3 py-2 text-zinc-400 hover:text-zinc-100 uppercase tracking-widest text-xs"
                >
                  Users
                </Link>
              </>
            )}
            <Link
              to="/status"
              target="_blank"
              rel="noreferrer"
              data-testid="nav-public-status-link"
              className="px-3 py-2 text-zinc-400 hover:text-zinc-100 uppercase tracking-widest text-xs"
            >
              Public ↗
            </Link>
            <div className="h-6 w-px bg-zinc-800 mx-1" />
            <div className="text-xs text-zinc-400" data-testid="current-user">
              <div className="font-medium text-zinc-200">{user?.name}</div>
              <div className="text-[10px] uppercase tracking-widest text-zinc-500">
                {user?.role}
              </div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              data-testid="logout-button"
              className="text-zinc-400 hover:text-zinc-100 uppercase tracking-widest text-xs"
            >
              Sign out
            </Button>
          </nav>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
    </div>
  );
}
